var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.50016 4.1996C2.50016 3.92346 2.72402 3.6996 3.00016 3.6996H13.0002C13.2763 3.6996 13.5002 3.92346 13.5002 4.1996V15.5329C13.5002 15.8091 13.2763 16.0329 13.0002 16.0329H3.00016C2.72402 16.0329 2.50016 15.8091 2.50016 15.5329V4.1996ZM3.50016 4.6996V15.0329H12.5002V4.6996H3.50016Z",
    fill: "#524986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 7.03293C6.94297 7.03293 7.16683 7.25679 7.16683 7.53293V11.8663C7.16683 12.1424 6.94297 12.3663 6.66683 12.3663C6.39069 12.3663 6.16683 12.1424 6.16683 11.8663V7.53293C6.16683 7.25679 6.39069 7.03293 6.66683 7.03293Z",
    fill: "#524986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 7.03293C9.60964 7.03293 9.8335 7.25679 9.8335 7.53293V11.8663C9.8335 12.1424 9.60964 12.3663 9.3335 12.3663C9.05735 12.3663 8.8335 12.1424 8.8335 11.8663V7.53293C8.8335 7.25679 9.05735 7.03293 9.3335 7.03293Z",
    fill: "#524986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 4.1996C0.833496 3.92346 1.05735 3.6996 1.3335 3.6996H14.6668C14.943 3.6996 15.1668 3.92346 15.1668 4.1996C15.1668 4.47574 14.943 4.6996 14.6668 4.6996H1.3335C1.05735 4.6996 0.833496 4.47574 0.833496 4.1996Z",
    fill: "#524986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99138 1.95926C6.07915 1.79914 6.24723 1.6996 6.42983 1.6996H9.59253C9.77665 1.6996 9.94588 1.80079 10.033 1.963L11.1073 3.963C11.1905 4.11795 11.1862 4.30525 11.096 4.45621C11.0057 4.60718 10.8427 4.6996 10.6668 4.6996H5.3335C5.15684 4.6996 4.9933 4.60638 4.90328 4.45438C4.81326 4.30238 4.81013 4.11417 4.89505 3.95926L5.99138 1.95926ZM6.72594 2.6996L6.17777 3.6996H9.83069L9.29354 2.6996H6.72594Z",
    fill: "#524986"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.866272)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNew);
export default __webpack_public_path__ + "static/media/delete-new.353bedad.svg";
export { ForwardRef as ReactComponent };